var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 56,
    viewBox: "0 0 316 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59063C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59063V50.0156C316 53.3207 313.321 56 310.016 56H5.98437C2.67929 56 0 53.3207 0 50.0156V3.59063Z",
    fill: "#E5E5E5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59063C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V48.0156C316 51.3207 313.321 54 310.016 54H5.98437C2.67929 54 0 51.3207 0 48.0156V3.59063Z",
    fill: "#E5E5E5",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59063C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V46.0156C316 49.3207 313.321 52 310.016 52H5.98437C2.67929 52 0 49.3207 0 46.0156V3.59063Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.59063C0 1.60758 1.60758 0 3.59062 0H312.409C314.392 0 316 1.60758 316 3.59062V44.0156C316 47.3207 313.321 50 310.016 50H5.98437C2.67929 50 0 47.3207 0 44.0156V3.59063Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditbox);
export default __webpack_public_path__ + "static/media/creditbox.42f5a2e953c6aba28dd93261fc3e9cfd.svg";
export { ForwardRef as ReactComponent };